import { Injectable } from '@angular/core';
import { isLocalStorageAvailable } from 'src/app/shared/helpers/helpers';

export const COOKIE_CONSENT_STATUS = 'cookie_consent_status';
export const COOKIE_CONSENT_TIME = 'cookie_consent_time';

@Injectable({ providedIn: 'root' })
export class CookieConsentService {
  storeConsentStatus: boolean | undefined;

  /**
   * Persists cookie consent to localStorage and updates in-memory state.
   * Skips the localStorage write if storage is unavailable (e.g. Safari ITP on /close/).
   */
  persistConsentStatus(consentStatus: boolean | undefined): void {
    this.storeConsentStatus = consentStatus;
    if (!isLocalStorageAvailable()) return;
    if (consentStatus === undefined || consentStatus === false) {
      localStorage.setItem(COOKIE_CONSENT_STATUS, 'true');
      localStorage.setItem(COOKIE_CONSENT_TIME, new Date().toISOString());
    } else {
      localStorage.removeItem(COOKIE_CONSENT_STATUS);
      localStorage.removeItem(COOKIE_CONSENT_TIME);
    }
  }
}
